import React from 'react';

// Todas las <img> van con loading=lazy salvo que el tag diga otra cosa (loading='eager').
// Se parchea createElement porque el JSX de react-scripts 3 compila a React.createElement.
const createElement = React.createElement;
React.createElement = function (type, props, ...children) {
  if (type === 'img') props = { loading: 'lazy', ...props };
  return createElement.call(this, type, props, ...children);
};

// Las imagenes que no estaban ya descargadas al aparecer (o al cambiar de src) se ocultan
// hasta que cargan y entonces hacen pop. Las que ya estan en cache salen tal cual.
const check = img => img.classList.toggle('imgLoading', !img.complete);

new MutationObserver(records => records.forEach(r => {
  if (r.type === 'attributes') return check(r.target);
  r.addedNodes.forEach(n => {
    if (n.nodeType !== 1) return;
    if (n.tagName === 'IMG') check(n);
    else n.querySelectorAll('img').forEach(check);
  });
})).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });

// load y error no burbujean, pero se pueden capturar desde el document.
// Timeout y no animationend: si la imagen ya tiene su propia animacion (img.over) el pop no
// llega a correr y la clase se quedaria puesta.
document.addEventListener('load', ({ target }) => {
  if (!target.classList || !target.classList.replace('imgLoading', 'imgPop')) return;
  setTimeout(() => target.classList.remove('imgPop'), 450);
}, true);
document.addEventListener('error', ({ target }) => target.classList && target.classList.remove('imgLoading'), true);
